import React from 'react';
import { connect } from 'react-redux';

import Cluster from '../Support/Cluster';
import dollarfy from '../Support/Dollarfy';

const printable = (props) => {

	const fields_first_half = props.fields.slice(0,4);
	const fields_second_half = props.fields.slice(4);

	// *--~~~--* *--~~~--* *--~~~--* *--~~~--* TBODY Column 1 *--~~~--* *--~~~--* *--~~~--* *--~~~--* //
	let col1 = Object.keys(fields_first_half)
		.map(field => {

			const m = fields_first_half[field];
			const data = props.measures[m.code];

			if(data === undefined)
				return null;

			if(m.name.indexOf('Counter') >= 0 && !props.matter.has_counter)
				return null;

			let content = null;
			if(m.type === 'breaklist' || m.type === 'traytable') {

				let total = 0;
				let rows = Object.keys(data)
					.map(row => {

						const d = data[row];
						const r = +row + 1;

						let row_classes = 'print--case__table__row';
						if(+d.hidden)
							row_classes += ' print--case__table__row--hidden';
						else
							total += +d.value;

						return (
							<tr className={row_classes} key={row}>
								<td>{r}</td>
								<td>{d.description === '' ? '--' : d.description}</td>
								<td>{dollarfy(d.value,0)}</td>
							</tr>
						);

					});

				let total_row = null;
				if(data.length > 1) {
					total_row = (
						<tr className='print--case__table__row print--case__table__row--total'>
							<td>&nbsp;</td>
							<td>Total</td>
							<td>{dollarfy(total,0)}</td>
						</tr>
					);
				}

				content = (
					<Cluster>
						{rows}
						{total_row}
					</Cluster>
				);

			}
			else if(m.type === 'slipslider') {

				content = (
					<Cluster>
						<tr className='print--case__table__row'>
							<td>&nbsp;</td>
							<td>Plaintiff</td>
							<td>{data}%</td>
						</tr>
						<tr className='print--case__table__row'>
							<td>&nbsp;</td>
							<td>Defendant</td>
							<td>{100 - data}%</td>
						</tr>
					</Cluster>
				);

			}
			else if(m.type === 'oddsball') {

				content = (
					<tr className='print--case__table__row'>
						<td>&nbsp;</td>
						<td>Estimate</td>
						<td>{data}%</td>
					</tr>
				);

			}

			return (
				<tbody key={field}>
					<tr className='print--case__table__segment'>
						<td colSpan='3'>
							<h5>{m.name}</h5>
						</td>
					</tr>
					{content}
				</tbody>
			);

		});


	// *--~~~--* *--~~~--* *--~~~--* *--~~~--* TBODY Column 2 *--~~~--* *--~~~--* *--~~~--* *--~~~--* //
	let col2 = Object.keys(fields_second_half)
		.map(field => {

			const m = fields_second_half[field];
			const data = props.measures[m.code];

			if(data === undefined)
				return null;

			if(m.name.indexOf('Counter') >= 0 && !props.matter.has_counter)
				return null;

			let content = null;
			if(m.type === 'breaklist' || m.type === 'traytable') {

				let total = 0;
				let rows = Object.keys(data)
					.map(row => {

						const d = data[row];
						const r = +row + 1;

						let row_classes = 'print--case__table__row';
						if(+d.hidden)
							row_classes += ' print--case__table__row--hidden';
						else
							total += +d.value;

						return (
							<tr className={row_classes} key={row}>
								<td>{r}</td>
								<td>{d.description === '' ? '--' : d.description}</td>
								<td>{dollarfy(d.value,0)}</td>
							</tr>
						);

					});

				let total_row = null;
				if(data.length > 1) {
					total_row = (
						<tr className='print--case__table__row print--case__table__row--total'>
							<td>&nbsp;</td>
							<td>Total</td>
							<td>{dollarfy(total,0)}</td>
						</tr>
					);
				}

				content = (
					<Cluster>
						{rows}
						{total_row}
					</Cluster>
				);

			}
			else if(m.type === 'slipslider') {

				content = (
					<Cluster>
						<tr className='print--case__table__row'>
							<td>&nbsp;</td>
							<td>Plaintiff</td>
							<td>{data}%</td>
						</tr>
						<tr className='print--case__table__row'>
							<td>&nbsp;</td>
							<td>Defendant</td>
							<td>{100 - data}%</td>
						</tr>
					</Cluster>
				);

			}
			else if(m.type === 'oddsball') {

				content = (
					<tr className='print--case__table__row'>
						<td>&nbsp;</td>
						<td>Estimate</td>
						<td>{data}%</td>
					</tr>
				);

			}

			return (
				<tbody key={field}>
					<tr className='print--case__table__segment'>
						<td colSpan='3'>
							<h5>{m.name}</h5>
						</td>
					</tr>
					{content}
				</tbody>
			);

		});


	// *--~~~--* *--~~~--* *--~~~--* *--~~~--* TBODY Column 3 *--~~~--* *--~~~--* *--~~~--* *--~~~--* //
	let offers = Object.keys(props.offers_primary)
		.map(row => {

			const o = props.offers_primary[row];
			const r = +row + 1;

			let row_classes = 'print--case__table__row';
			if(o.accepted) row_classes += ' print--case__table__row--accepted';

			return (
				<tr className={row_classes} key={row}>
					<td>{r}</td>
					<td>{o.description}{o.accepted ? '**' : ''}</td>
					<td>{dollarfy(o.value,0)}</td>
				</tr>
			);

		});

	let col3 = (
		<tbody>
			<tr className='print--case__table__segment'>
				<td colSpan='3'>
					<h5>Offers</h5>
				</td>
			</tr>
			{offers}
		</tbody>
	);


	// *--~~~--* *--~~~--* *--~~~--* *--~~~--* TBODY Column 4 *--~~~--* *--~~~--* *--~~~--* *--~~~--* //
	let counters = Object.keys(props.offers_counter)
		.map(row => {

			const o = props.offers_counter[row];
			const r = +row + 1;

			let row_classes = 'print--case__table__row';
			if(o.accepted) row_classes += ' print--case__table__row--accepted';

			return (
				<tr className={row_classes} key={row}>
					<td>{r}</td>
					<td>{o.description}{o.accepted ? '**' : ''}</td>
					<td>{dollarfy(o.value,0)}</td>
				</tr>
			);

		});

	let col4 = (
		<tbody>
			<tr className='print--case__table__segment'>
				<td colSpan='3'>
					<h5>Counter Offers</h5>
				</td>
			</tr>
			{counters}
		</tbody>
	);


	return (
		<section className='print print--case'>

			<div className='print--case__block print--case__block--left'>

				<h4 className='print--case__block__name'>Claim</h4>

				<table className='print--case__dual-table'>
					<tbody>
						<tr>
							<td className='print--case__dual-table__cell'>
								<table className='print--case__table'>
									{col1}
								</table>
							</td>
							<td className='print--case__dual-table__cell'>
								<table className='print--case__table'>
									{col2}
								</table>
							</td>
						</tr>
					</tbody>
				</table>

			</div>

			<div className='print--case__block print--case__block--right'>

				<h4 className='print--case__block__name'>Offers</h4>

				<table className='print--case__dual-table'>
					<tbody>
						<tr>
							<td className='print--case__dual-table__cell'>
								<table className='print--case__table'>
									{col3}
								</table>
							</td>
							<td className='print--case__dual-table__cell'>
								<table className='print--case__table'>
									{col4}
								</table>
							</td>
						</tr>
					</tbody>
				</table>

			</div>

		</section>
	);
}


const mapStateToProps = state => {
	return {
		matter: state.matter,
		fields: state.fields,
		measures: state.measures,
		results_plaintiff: state.results_plaintiff,
		results_defendant: state.results_defendant,
		offers_primary: state.offers_primary,
		offers_counter: state.offers_counter
	};
}

export default connect(mapStateToProps)(printable);


// WEBPACK FOOTER //
// ./src/Blocks/Printable.js